import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import LOG, { log } from "../../../UTIL/LOG";
import GameInstance from "../GameInstance";
import MessageItem from "./MessageItem";
import ARRAY from "../../../UTIL/ARRAY";

class Messages
{
    public conquer          : CONQUER;
    public tabs             : any;
    public items            : any;
    private gameInstance    : GameInstance;
    private gameID          : any;
    private fromAvatarID    : any;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
    }

    public init()
    {
        this.gameID         = this.gameInstance.gameID;
        this.fromAvatarID   = this.conquer.Avatars.ME.avatarID
    }

    public async set( toAvatarID:any, data:any, fromAvatarID?:any ) : Promise<any>
    {
        if( !data.type ) data.type = "Message";

        let result = await this.conquer.do( ACTIONS.GAME_MESSAGES_SET, { gameID:this.gameID, fromAvatarID:fromAvatarID || this.fromAvatarID, toAvatarID:toAvatarID, data:data } );
        
        return Promise.resolve( new MessageItem( this, result ));
    }
 
    public async get() : Promise<any>
    {
        let results : any = await this.conquer.do( ACTIONS.GAME_MESSAGES_GET, { gameID:this.gameID, toAvatarID:this.fromAvatarID } );
        return Promise.resolve( this.processData( results ) );
    }

    public getTab( type:string )
    {
        if( !this.tabs[ type ] ) this.tabs[ type ] = [];
        return this.tabs[ type ];
    }

    private processData( messagesData : any )
    {
        this.tabs       = {};
        this.items      = {};

        for( let n in messagesData )
        {
            let messageItem = new MessageItem( this, messagesData[n] );
            this.getTab( messageItem.type ).push( messageItem );
        }
 
        return this.tabs;
    }
  
    public remove( messageItem:MessageItem )
    {
        if( this.tabs[ messageItem.type ] ) ARRAY.removeItem( this.tabs[ messageItem.type ], messageItem );
    }
}

export default Messages;